<template>
    <brick-octagon-base class="journey-brick" :class="classList" @click.native="handleClick">
        <template>
            <component v-if="showSettings"
                       :is="editorType"

                       :value="config"
                       :name="name"
                       :show="showSettings"
                       :availableConditions="availableConditions"
                       @hide="showSettings = false"
                       @save="$emit('settings-changed', $event)"
                       @delete="$emit('delete-brick', false)"
            />

        </template>
    </brick-octagon-base>
</template>

<script>
    import brickTypes from "../../Bricks/brick-types";

    import journeyBrickMixin from '../../Mixins/journey-brick'

    import BrickOctagonBase from './../BrickOctagonBase.vue';
    import BrickSettingsAudienceFilter from './BrickSettings/AudienceFilter/AudienceFilterBrickSettings.vue';

    const brickTypeEditorMapping = {
        [brickTypes.audienceFilter]: BrickSettingsAudienceFilter
    };

    export default {
        name: 'journey-brick-octagon',
        mixins: [journeyBrickMixin],
        components: {
            BrickOctagonBase
        },
        created() {
            this.prevX = this.x;
            this.prevY = this.y;
        },
        methods: {
            handleClick(){
                const vm = this;
                
                if(vm.x === vm.prevX && vm.y === vm.prevY){
                    vm.showSettings = true;
                }
                
                vm.prevX = vm.x;
                vm.prevY = vm.y;
            }
        },
        computed: {
            editorType(){
                return brickTypeEditorMapping[this.type];
            },
            classList() {
                const vm = this;

                const list = [];

                list.push(vm.config.goal === true ? 'goal' : vm.brickTypeName);
                list.push(vm.isActive ? 'active' : 'undefined');

                return list;
            }
        },
        data() {
            return {
                showSettings: false,
                prevX: 0,
                prevY: 0
            }
        },
        props: {
            id: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            config: {
                type: Object,
                required: true
            },
            availableConditions: {
                type: Array,
                required: true
            }
        }
    }
</script>

<style scoped src="../../Style/journey-brick-octagon.scss" lang="scss"/>